import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_checkmark",
  "use": "svg_checkmark-usage",
  "viewBox": "0 0 10 7",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 7\" id=\"svg_checkmark\"><path d=\"M.833 3.14 4.061 5.5l4.575-5\" stroke=\"#000\" stroke-width=\"1.3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol